import React, { ReactElement, useEffect, useState } from 'react';
import H2 from '../typography/H2';
import { getAnonymousPaymentDetails } from 'utils/helpers/browser/anonymousPaymentDetail';
import MembershipPayment from 'components/pages/dashboard/MembershipPayment';
import { getDiscipline } from 'utils/helpers/browser/discipline';
import { getTranslation, useTranslation } from 'utils/localization';
import { TNamespaceEnum } from 'types/types';
import { PaymentData } from 'submodules/api_middleware/src/interfaces/api/AnonymousPaymentDataInterface';
import styles from 'components/anonymous-payment/PaymentDetail.module.scss';
import Icon from 'components/icon/Icon';
import Check from 'components/icon/icons/green_check.svg';
import { MembershipPaymentStatus } from 'components/interfaces/MembershipPaymentInterface';

/**
 * Payment detail page for given member.
 * @param memberId internal member ID - used within organizationinternal member ID - used within organization
 * @param nationalIdentifier the birth number of member
 */
const PaymentDetail = ({
    memberId,
    nationalIdentifier,
    nationalIdentifierIsRequired,
}: {
    memberId: string;
    nationalIdentifier: string;
    nationalIdentifierIsRequired: boolean;
}): ReactElement => {
    const [paymentData, setPaymentData] = useState<PaymentData>(undefined);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    useEffect(() => {
        setLoading(true);

        if (memberId && (!nationalIdentifierIsRequired || nationalIdentifier)) {
            getAnonymousPaymentDetails(memberId, nationalIdentifier).then(
                (response) => {
                    const paymentData = response.data;

                    setPaymentData(paymentData);
                    setLoading(false);
                }
            );
        }
    }, [memberId, nationalIdentifier, nationalIdentifierIsRequired]);

    return (
        <>
            {loading && (
                <p>
                    {getTranslation(
                        t,
                        TNamespaceEnum.common,
                        'general.loadingData'
                    )}
                </p>
            )}
            {!loading &&
                paymentData &&
                paymentData.status === MembershipPaymentStatus.Paid && (
                    <div className={styles.successText}>
                        <Icon icon={Check} className={styles.icon} />
                        <H2>
                            {
                                t(
                                    'Toast.payment_state_completed_message_title'
                                ) as string
                            }
                        </H2>
                        <div>{t('Toast.payment_state_completed_message')}</div>
                    </div>
                )}
            {!loading &&
                paymentData &&
                paymentData.status !== MembershipPaymentStatus.Paid && (
                    <MembershipPayment
                        amount={paymentData.amount}
                        administrationFee={paymentData.administration_fee}
                        bankAccount={paymentData.bank_account}
                        iban={paymentData.iban}
                        variableSymbol={paymentData.variable_symbol}
                        dueDate={paymentData.due_date}
                        discipline={getDiscipline()}
                        personId={paymentData.person_id}
                    />
                )}
        </>
    );
};

export default PaymentDetail;
